import React from 'react';

import { upperFirst } from 'lodash';
import { MdNewReleases } from 'react-icons/md';
import { FormattedMessage } from 'react-intl';

import { Button, Collapse, S, T } from '@modules/shared/components';

import { PanelTitle } from '../constants';
import { PermissionsPanel } from './components/PermissionsPanel';
import styles from './permissionsTab.less';

const { Panel } = Collapse;

export const PermissionsTab = () => {
  const Panels = [
    PanelTitle.ACTIVITY,
    PanelTitle.ADVANCEMENT,
    PanelTitle.CALENDAR,
    PanelTitle.FINANCE,
    PanelTitle.LEADERSHIP,
    PanelTitle.MEMBERSHIP,
    PanelTitle.MESSAGING,
    PanelTitle.UNIT,
  ];

  return (
    <div className={styles.tabContainer}>
      <div className={styles.legendContainer}>
        <div className={styles.instructionContainer}>
          <div className={styles.fakeChkbx}></div>
          <S size="3" bold>
            <FormattedMessage id="permissionManager.permissionTab.roleRequired" />
          </S>
        </div>
        <div className={styles.instructionContainer}>
          <MdNewReleases className={styles.istructionIcon} />
          <S size="3" bold>
            <FormattedMessage id="permissionManager.permissionTab.recommendedPosition" />
          </S>
        </div>
      </div>
      <Collapse
        expandIconPosition="right"
        bordered={false}
        className={styles.collapse}
      >
        {Panels.map(panelType => (
          <Panel
            header={
              <div className={styles.panelHeader}>
                <T noMargin colored bold size="2">
                  {
                    <FormattedMessage
                      id="permissionManager.permissionTab.panelTitle"
                      values={{ panelTitle: upperFirst(panelType) }}
                    />
                  }
                </T>
                <Button
                  shape="round"
                  type="primary"
                  size="large"
                  uppercase={false}
                >
                  <FormattedMessage id="permissionManager.permissionTab.applyChanges" />
                </Button>
              </div>
            }
            key={panelType}
            className={styles.panel}
          >
            <PermissionsPanel panelType={panelType} />
          </Panel>
        ))}
      </Collapse>
    </div>
  );
};
